<template>
  <!--==================
    component shows wallet balance and history (operator)
    ===============-->

  <div class="position-relative">
    <div class="d-flex bg-light p-3 rounded">
      <h5 class="font-weight-bold col-md-3">Balance: {{ currencySymbol }} {{ 25 | currency }}</h5>
      <a class="btn btn-primary btn-sm" href="/dashboard/user/wallet/add-fund" target="_blank"> Add Fund</a>
    </div>

    <div class="mt-5">
      <div class="h5 font-weight-bold p-3">Payment History</div>

      <nav>
        <div class="nav nav-tabs flex-row mb-4" id="nav-tab" role="tablist">
          <a
            class="nav-item nav-link active"
            id="nav-fund-tab"
            data-toggle="tab"
            href="#nav-fund"
            role="tab"
            aria-controls="nav-fund"
            aria-selected="true"
            data-selector="fund"
          >
            Fund
          </a>
          <a
            class="nav-item nav-link"
            id="nav-quote-tab"
            data-toggle="tab"
            href="#nav-quote"
            role="tab"
            aria-controls="nav-quote"
            aria-selected="false"
            data-selector="quote"
          >
            Quote
          </a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <!-- fund history -->
        <div class="tab-pane fade show active" id="nav-fund" role="tabpanel" aria-labelledby="nav-fund-tab">
          <div class="card">
            <div class="table-responsive">
              <table class="table table-bordered table-sm table-nowrap card-table">
                <thead>
                  <tr>
                    <th scope="col">Order No.</th>
                    <th scope="col">Reference No.</th>
                    <th scope="col">Amount TZS</th>
                    <th scope="col">Payment Method</th>
                    <th scope="col">Status</th>
                    <th scope="col">Requested Date</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!fundHistory.length">
                    <td colspan="6" class="text-center text-muted font-italic">There is no payment history</td>
                  </tr>
                  <tr v-for="history in fundHistory" :key="history.orderId">
                    <td>{{ history.orderId }}</td>
                    <td>
                      {{ history.reference ? history.reference : "-" }}
                    </td>
                    <td>{{ history.amount | currency }}</td>
                    <td>
                      {{ history.channel ? history.channel : "-" }}
                    </td>
                    <td>{{ history.status }}</td>
                    <td>{{ history.createdAt | utcDateToLocalDate("yyyy-mm-dd HH:MM") }}</td>
                    <td class="text-right">
                      <button
                        @click="cancelOrder(history.orderId)"
                        :disabled="history.status != 'PENDING'"
                        class="btn btn-sm btn-danger ml-2"
                      >
                        Cancel
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- quote history -->
        <div class="tab-pane fade" id="nav-quote" role="tabpanel" aria-labelledby="nav-quote-tab">
          <div class="card">
            <div class="table-responsive">
              <table class="table table-bordered table-sm table-nowrap card-table">
                <thead>
                  <tr>
                    <th scope="col">Quote</th>
                    <th scope="col">Package</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Paid Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!quoteHistory.length">
                    <td colspan="6" class="text-center text-muted font-italic">There is no payment history</td>
                  </tr>
                  <tr v-for="history in quoteHistory" :key="history.paidDate">
                    <td>{{ history.qoute }}</td>
                    <td>{{ history.package }}</td>
                    <td>{{ history.amount | currency }}</td>
                    <td>{{ history.currency }}</td>
                    <td>{{ history.paidDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OperatorWallet",

  data() {
    return {
      currencySymbol: "$",
      quoteHistory: [],
    };
  },

  computed: {
    ...mapGetters(["user", "operatorFundHistory"]),

    fundHistory() {
      let sortedHistory = this.operatorFundHistory;

      // sort history by last created date
      sortedHistory.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      return sortedHistory;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchOperatorFundHistory(this.user.id);

      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions([
      "hideBarLoading",
      "fetchOperatorFundHistory",
      "cancelPaymentOrder",
      "showSpinnerLoading",
      "hideSpinnerLoading",
    ]),

    async cancelOrder(orderId) {
      this.showSpinnerLoading();
      const status = await this.cancelPaymentOrder(orderId);

      if (status.data.resultcode === "000") {
        $.alert("order cancelled successfully");
        this.fetchOperatorFundHistory(this.user.id);
      } else {
        $.alert("order cancellation failed");
      }

      this.hideSpinnerLoading();
    },
  },
};
</script>
